export default __webpack_public_path__ + "static/media/Rekindled Strike.8419c43c.png";